import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { push } from 'connected-react-router';
import {
  createStyles, ListItem, ListItemText, makeStyles, Theme,
} from '@material-ui/core';
import clsx from 'clsx';

import noop from '../../utility/noop';

const useStyles = makeStyles(({ spacing, palette }: Theme) => createStyles({
  root: {
    color: palette.menuAction.active,
    '&:hover': {
      backgroundColor: 'initial',
      color: palette.navBar.hover,
      textDecoration: 'none',
    },
  },
  text: {
    fontSize: '12px',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 500,
  },
  nested: {
    paddingLeft: spacing(4),
  },
  active: {
    color: palette.navBar.active,
  },
}), { name: 'MainBarDrawerLink' });

type Props = {
  nested?: boolean;
  to?: string;
  label: React.ReactNode;
  children?: React.ReactNode;

  onClick?: React.MouseEventHandler;
};

const MainBarDrawerLink = ({
  nested = false,
  to,
  label,
  children = null,
  onClick = noop,
}: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const clickHandler = useCallback((e: React.MouseEvent) => {
    onClick(e);

    if (!e.defaultPrevented && to) {
      dispatch(push(to));
    }
  }, [onClick, to, dispatch]);

  const active = useRouteMatch(to ?? '') && to;

  return (
    <ListItem
      tabIndex={-1}
      button
      className={clsx({
        [classes.nested]: nested,
        [classes.active]: active,
      })}
      classes={{
        root: classes.root,
      }}
      onClick={clickHandler}
    >
      <ListItemText
        primary={label}
        classes={{
          primary: classes.text,
        }}
      />
      {children}
    </ListItem>
  );
};

export default MainBarDrawerLink;
